import React, { useState, useRef, useEffect } from 'react';
import { 
  Settings, 
  User, 
  ChevronLeft, 
  ChevronRight,
  UserCircle,
  Settings2,
  HelpCircle,
  LogOut
} from 'lucide-react';
import "../css/user-menu.css";
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';

// ... (keep your existing imports and component definitions)

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [names, setNames] = useState("");
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { isLoggedIn, userRole, login, logout } = useAuth();
  
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const email = localStorage.getItem('email');
    if (email) {
        setEmail(email);
    }

    const names = localStorage.getItem('names');
    if (names) {
        setNames(names);
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    // Implement your logout logic here
    console.log('Logging out...');
    logout();
    navigate('/login');
  };


  return (
    <div className="user-menu" ref={menuRef}>
      <button 
        className="user-icon"
        onClick={() => setIsOpen(!isOpen)}
      >
        <User className="icon" />
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-header">
            <div className="user-info">
              <div className="user-avatar">
                <UserCircle />
              </div>
              <div className="user-details">
                <div className="user-name">{email}</div>
                <div className="user-email">{names}</div>
                <div className="user-email">{userRole}</div>
              </div>
            </div>
          </div>
          <div className="dropdown-items">
            <button className="dropdown-item">
              <UserCircle size={18} />
              View Profile
            </button>
            <button className="dropdown-item">
              <Settings2 size={18} />
              Account Settings
            </button>
            <button className="dropdown-item">
              <HelpCircle size={18} />
              Help & Support
            </button>
            <div className="dropdown-divider" />
            <button 
              className="dropdown-item"
              onClick={handleLogout}
            >
              <LogOut size={18} />
              Log Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export  {UserMenu};
